export default __webpack_public_path__ + "static/media/resources-and-production-5.54facc96.png";